// Angular Files
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Angular Material Files
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { A11yModule } from '@angular/cdk/a11y';

// Other External Files
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

// Component Files
import { TellerOnlineSharedModule } from 'teller-online-libraries/shared';
import { SelectPaymentComponent } from './select-payment.component';

// Teller Online Library Files

@NgModule({
    declarations: [SelectPaymentComponent],
    imports: [
        TellerOnlineSharedModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatListModule,
        MatDividerModule,
        MatIconModule,
        MatInputModule,
        NgxMaskDirective,
        NgxMaskPipe,
        MatFormFieldModule,
        A11yModule
    ],
    providers: [
        { provide: MAT_BOTTOM_SHEET_DATA, useValue: null },
        provideNgxMask()
    ],
    exports: [SelectPaymentComponent]

})

export class SelectPaymentModule { }
